/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export * from './header.service';
export * from './settings.service';
export * from './policiesLists.service';
export * from './updateStatus.service';
export * from './loading.service';
export * from './staticPage.service';
export * from './resendCredential.service';
export * from './eventDetail.service';
export * from './button.service';
export * from './eventTimeline.service';
export * from './error-content.plugin';
